module.exports = __webpack_public_path__ + "static/media/hoodie.baa57d5e.png";